/**
 * Created by hernanherreros on 2019-05-09
 */

import * as React from 'react'
import Content from '../../components/Layout/Content'
import withWizardProps, { WizardProps } from '../../wrappers/withWizardParams'
import { flowRight } from 'lodash'
import ActivitiesExtension from '../../extensions/activities'
import ActivitiesLowcostExtension from '../../extensions/activities-lowcost'
import { i18n } from '../../providers/Locale/localeProvider'
import { openAppURL } from '../../helpers/general'
import withURLParams, { URLParamsComponentProps } from '../../providers/URLParams/withURLParams'
import withReservation, { ReservationProps } from '../../providers/Reservation/withReservation'
import { message } from 'antd'

interface Props extends WizardProps, URLParamsComponentProps, ReservationProps {
}

interface State {
}

class Activities extends React.Component<Props, State> {
  handleSuccess = async () => {
    const { params, reservation } = this.props

    if (params && params.returnTo) {
      openAppURL(params.returnTo.replace('%3Aemail', reservation.data.Email))
    }

    message.success(i18n._('Actividades actualizadas correctamente'))
  }

  render () {
    const { reservation } = this.props

    if(reservation.data.CongressSlug === "sem-internacional-2019" || reservation.data.CongressSlug === "sem-matematicas-2019" || reservation.data.CongressSlug === "sem-icec-2019") {
      return (
        <Content>
          <ActivitiesLowcostExtension
            key={i18n.language}
            editingSelection
            nextLabel={i18n._('Guardar cambios')}
            onSuccess={this.handleSuccess}
            isUpdate={true}
          />
        </Content>
      )
    }

    return (
        <Content>
          <ActivitiesExtension
            key={i18n.language}
            editingSelection
            nextLabel={i18n._('Guardar cambios')}
            onSuccess={this.handleSuccess}
            isUpdate={true}
          />
        </Content>
    )
  }
}

export default flowRight([withWizardProps, withURLParams, withReservation])(Activities)
